/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yourlistingandimageshavebeenupdatedsuccessfully7Inputs */

const en_yourlistingandimageshavebeenupdatedsuccessfully7 = /** @type {(inputs: Yourlistingandimageshavebeenupdatedsuccessfully7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your listing and images have been updated successfully.`)
};

const de_yourlistingandimageshavebeenupdatedsuccessfully7 = /** @type {(inputs: Yourlistingandimageshavebeenupdatedsuccessfully7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Ort und deine Bilder wurden aktualisiert.`)
};

/**
* | output |
* | --- |
* | "Your listing and images have been updated successfully." |
*
* @param {Yourlistingandimageshavebeenupdatedsuccessfully7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const yourlistingandimageshavebeenupdatedsuccessfully7 = /** @type {((inputs?: Yourlistingandimageshavebeenupdatedsuccessfully7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yourlistingandimageshavebeenupdatedsuccessfully7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yourlistingandimageshavebeenupdatedsuccessfully7(inputs)
	return de_yourlistingandimageshavebeenupdatedsuccessfully7(inputs)
});
export { yourlistingandimageshavebeenupdatedsuccessfully7 as "yourListingAndImagesHaveBeenUpdatedSuccessfully" }